export const extractErrorMeta = (error, skipStack = false) => ({
    error: {
        ...(skipStack ? {} : { stack: error.stack }),
        name: error.name,
    },
});
//# sourceMappingURL=utils.js.map